import { createSlice } from "@reduxjs/toolkit";
import { setCurrentProject } from "../project/projectSlice";

const initialState = {
  currentBrand: null,
  brands: [],
  ready: false,
};

const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setCurrentBrand: (state, action) => {
      state.currentBrand = action.payload;
      if (action.payload?.hash) {
        localStorage.setItem("currentBrandHash", action.payload.hash);
      } else {
        localStorage.removeItem("currentBrandHash");
      }
    },
    setBrands: (state, action) => {
      state.brands = action.payload;
    },
    setBrandsReady: (state, action) => {
      state.ready = action.payload;
    },
    clearBrandState: (state) => {
      state.currentBrand = null;
      state.brands = [];
      state.ready = false;
      localStorage.removeItem("currentBrandHash");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setCurrentProject, (state) => {
      state.ready = false;
      state.brands = [];
      state.currentBrand = null;
    });
  },
});

export const { setCurrentBrand, setBrands, setBrandsReady, clearBrandState } =
  brandSlice.actions;

export default brandSlice.reducer;
